'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bicycle';
var width = 640;
var height = 512;
var aliases = [128690];
var unicode = 'f206';
var svgPathData = ['M64 352c0 44.2 35.8 80 80 80 38.7 0 71-27.5 78.4-64l-117.2 0c9.4-18.8 25.3-50.6 47.8-95.5-2.9-.3-5.9-.5-8.9-.5-44.2 0-80 35.8-80 80zm352 0c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80c-4 0-8 .3-11.8 .9 26.1 53.6 40.7 83.7 43.9 90.2l-43.2 21c-3.2-6.5-17.8-36.6-43.9-90.2-15.4 14.6-25 35.2-25 58.1z', 'M313.6 32l166.4 0 0 48-89.6 0 72.2 148.4c10.7-2.9 21.9-4.4 33.4-4.4 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-42 20.2-79.2 51.4-102.6l-20.4-41.9-73.6 147.2-6.6 13.3-47.8 0c-7.9 63.1-61.7 112-127 112-70.7 0-128-57.3-128-128S73.3 224 144 224c10.8 0 21.2 1.3 31.2 3.8l28.5-56.9-11.5-26.9-64.2 0 0-48 95.8 0c2.8 6.5 9.7 22.5 20.6 48l123.7 0c-28.6-58.8-46.8-96.2-54.5-112zM228.5 228.7l-45.6 91.3 84.8 0-39.1-91.3zM305.7 287l47.5-95-88.2 0 40.7 95zm168.7 75.5L441 293.9c-15.4 14.6-25 35.2-25 58.1 0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80c-4 0-8 .3-11.8 .9 26.1 53.6 40.7 83.7 43.9 90.2l-43.2 21-10.5-21.6zM144 368l-38.8 0c9.4-18.8 25.3-50.6 47.8-95.5-2.9-.3-5.9-.5-8.9-.5-44.2 0-80 35.8-80 80s35.8 80 80 80c38.7 0 71-27.5 78.4-64L144 368z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBicycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;